import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckFat = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.8122 8.52284L10.7737 20.5603C10.6344 20.6997 10.4691 20.8102 10.2871 20.8856C10.105 20.961 9.90996 20.9998 9.71295 20.9998C9.51594 20.9998 9.32085 20.961 9.13884 20.8856C8.95683 20.8102 8.79146 20.6997 8.65217 20.5603L1.93779 13.8103C1.65699 13.5291 1.49927 13.1479 1.49927 12.7505C1.49927 12.3531 1.65699 11.9719 1.93779 11.6906L4.18779 9.44065C4.46813 9.16024 4.84809 9.00223 5.2446 9.00118C5.64111 9.00013 6.0219 9.15611 6.30373 9.43503L9.73873 12.7416L9.74904 12.7519L18.4425 4.18596C18.7236 3.90602 19.1042 3.74884 19.5009 3.74884C19.8977 3.74884 20.2782 3.90602 20.5594 4.18596L22.8094 6.39471C22.9498 6.53394 23.0614 6.69958 23.1376 6.88209C23.2139 7.06461 23.2533 7.2604 23.2535 7.45819C23.2538 7.65598 23.2149 7.85188 23.1392 8.03459C23.0634 8.21731 22.9523 8.38324 22.8122 8.52284Z",
		fill: "current"
	})
});
export default SvgCheckFat;
